module.exports = __webpack_public_path__ + "static/media/arrow_down.6acdcce8.svg";